<template>
    <div class="pop_up_layer find_account" style="display: block"></div>
    <div class="pop_up pop_detail event_apply" id="find_account" style="display: block">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <div class="pop_tit">
            <p v-text="state.title"></p>
        </div>

        <div class="content_wrap sign_form">
            <ul>
                <li>
                    <label for="name">이름</label>
                    <input type="text" id="name" v-model="state.name" placeholder="이름을 입력해주세요." />
                </li>

                <li>
                    <label for="phoneNum">휴대폰</label>
                    <input type="text" id="phoneNum" v-model="state.phoneNum" placeholder="휴대폰을 입력해주세요." />
                </li>

                <li>
                    <label for="email">이메일</label>
                    <input type="email" id="email" v-model="state.email" placeholder="이메일을 입력해주세요." />
                </li>

                <li class="checkbox_wrap">
                    <label for="generation1">나이</label>
                    <div class="check_age">
                        <label for="generation1">
                            <input type="radio" id="generation1" name="generation" v-model="state.age" :value="1" :checked="state.age === 1" />
                            <em></em>
                            <span class="form_li_tit">10대</span>
                        </label>
                        <label for="generation2">
                            <input type="radio" id="generation2" name="generation" v-model="state.age" :value="2" :checked="state.age === 2" />
                            <em></em>
                            <span class="form_li_tit">20대</span>
                        </label>
                        <label for="generation3">
                            <input type="radio" id="generation3" name="generation" v-model="state.age" :value="3" :checked="state.age === 3" />
                            <em></em>
                            <span class="form_li_tit">30대</span>
                        </label>
                        <label for="generation4">
                            <input type="radio" id="generation4" name="generation" v-model="state.age" :value="4" :checked="state.age === 4" />
                            <em></em>
                            <span class="form_li_tit">40대</span>
                        </label>
                        <label for="generation5">
                            <input type="radio" id="generation5" name="generation" v-model="state.age" :value="5" :checked="state.age === 5" />
                            <em></em>
                            <span class="form_li_tit">50대</span>
                        </label>
                        <label for="generation6">
                            <input type="radio" id="generation6" name="generation" v-model="state.age" :value="6" :checked="state.age === 6" />
                            <em></em>
                            <span class="form_li_tit">60대</span>
                        </label>
                        <label for="generation7">
                            <input type="radio" id="generation7" name="generation" v-model="state.age" :value="7" :checked="state.age === 7" />
                            <em></em>
                            <span class="form_li_tit">70대 이상</span>
                        </label>
                        <!-- <label for="generation9">
                            <input type="radio" id="generation9" name="generation" :value="9" :checked="state.age === 9" />
                            <em></em>
                            <span class="form_li_tit">기타</span>
                        </label> -->
                    </div>
                </li>

                <li class="checkbox_wrap">
                    <label for="chk1" @click="showTerms">
                        <input id="chk1" type="checkbox" v-model="state.isAgree" ref="isAgree" disabled />
                        <em></em>
                        <span>개인정보 수집·이용 동의 (클릭 시 개인정보 처리방침 안내)</span>
                    </label>
                </li>
                <li v-if="props.isEventModal">
                    <label for="email">캠페인 참여 후기/더 알고 싶은 성매매 산업 내용(선택)</label>
                    <textarea class="review textarea custom_scroll" v-model="state.review" placeholder="내용을 입력해주세요."></textarea>
                </li>
            </ul>

            <p class="etc_content">개인정보 수집 및 이용 동의 선택 후 캠페인 참여 및 상품권 당첨, 발송이 가능합니다.</p>
            <div class="btn_wrap">
                <button class="submit_btn _gray" @click="closeModal">취소</button>
                <button class="submit_btn" @click="callbackFun" v-if="state.isPossible" :disabled="!state.isAgree">신청</button>
                <button class="submit_btn _gray" @click="closeModal" v-else>닫기</button>
            </div>
        </div>
    </div>
    <EventTermsModal v-if="modal.isShow" @close="applyTerms"></EventTermsModal>
</template>
<script lang="ts" config>
    import { reactive, onMounted, onUnmounted, watch, EventTermsModal } from "@/BaseComponent";
    export default {
        props: {
            title: {
                type: String,
                default: "",
            },
            isEventModal: {
                type: Boolean,
                default: false,
            },
            // name: { type: String, default: "" },
            // phoneNum: { type: String, default: "" },
            // email: { type: String, default: "" },
            // age: { type: Number, default: 1 },
            // isAgree: {
            //     type: Boolean,
            //     default: false,
            // },
        },
        emits: ["close", "callback"],
        components: { EventTermsModal },
        setup(props: any, { emit }: any) {
            const state = reactive({
                title: "" as string,
                name: "" as string,
                phoneNum: "" as string,
                email: "" as string,
                age: null as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 9 | null,
                isAgree: false as boolean,
                isPossible: false as boolean,
                review: "" as string,
            });

            const modal = reactive({
                isShow: false as boolean,
                tab: 0 as number,
                title: "" as string,
                content: "" as string,
            });

            onMounted(() => {
                state.title = props.title;
                state.name = "";
                state.phoneNum = "";
                state.email = "";
                state.age = null;
                state.isAgree = false;

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.title = "";
                state.name = "";
                state.phoneNum = "";
                state.email = "";
                state.age = 1;
                state.isAgree = false;
                state.review = "";
            });

            watch(state, () => {
                if (state.name !== "" && state.phoneNum !== "" && state.email !== "" && state.age && state.isAgree) {
                    state.isPossible = true;
                } else {
                    state.isPossible = false;
                }
            });

            const closeModal = () => {
                emit("close");
            };

            const callbackFun = () => {
                const param = {
                    name: state.name,
                    phoneNum: state.phoneNum,
                    email: state.email,
                    isAgree: 1,
                    age: state.age,
                    review: state.review,
                    action: "applyContent",
                };

                emit("callback", param);
            };

            // 틀린그림찾기 개인정보 처리방침 동의 모달
            const showTerms = () => {
                if (!state.isAgree) {
                    modal.isShow = true;
                } else {
                    state.isAgree = false;
                }
            };

            const applyTerms = () => {
                modal.isShow = false;
                state.isAgree = true;
            };

            return { state, modal, props, closeModal, callbackFun, showTerms, applyTerms };
        },
    };
</script>

<style scoped>
    .textarea.review {
        width: 100%;
        font-size: 13px;
    }
    .pop_up.event_apply {
        max-width: 600px;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .check_age {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        row-gap: 5px;
    }
    .check_age .age_content {
        display: flex;
        align-items: center;
    }
    .check_age .age_content span.form_li_tit {
        word-break: keep-all;
    }

    .checkbox_wrap label + label {
        margin-left: 0;
    }

    .etc_content {
        margin-top: 10px;
        font-size: 13px;
        /* color: blue; */
    }
</style>
